import { render, staticRenderFns } from "./firmPurse.vue?vue&type=template&id=428fa22d&scoped=true&"
import script from "./firmPurse.vue?vue&type=script&lang=js&"
export * from "./firmPurse.vue?vue&type=script&lang=js&"
import style0 from "./firmPurse.vue?vue&type=style&index=0&id=428fa22d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428fa22d",
  null
  
)

export default component.exports